import { useTranslation } from "react-i18next";
import { Button, Box, Container } from "@mui/material";
import {
  IProgress,
  ISessionProps,
  IntegrationPathType,
  SDKTestType,
  SessionStatus,
} from "../components/IProgress";
import { useLocation, useNavigate } from "react-router-dom";
import { InteractiveCard, Typography, Badge } from "@appsflyer/fe-ui-core";
import CardContent from "@mui/material/CardContent";
import transition from "../components/transition";
import { DeeplinkType } from "../../deeplinking/DeferredOrDirect";
import { amplitudeTrack_continue } from "../../services/utils";
// import StarIcon from "@mui/icons-material/Star";

const TestingTypePath = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const toTestConsole = () => {
    // Initialize progress with a copy of progressArr
    const progressArr: IProgress[] = location.state?.progress.slice();

    if (location.state?.path === IntegrationPathType.StartSDK) {
      progressArr.push({
        id: "startsdk_register",
        text: "progress_startsdk_register",
        order: 6,
      });
    } else if (location.state?.path === IntegrationPathType.InApp) {
      progressArr.push({
        id: "inapp_register",
        text: "progress_inapp_register",
        order: 5,
      });
    } else if (location.state?.path === IntegrationPathType.DeepLink) {
      progressArr.push({
        id: "dl_register",
        text: "progress_dl_register",
        order: 5,
      });
    } else if (location.state?.path === IntegrationPathType.AdRevenue) {
      progressArr.push({
        id: "adrevenue_testevents_automated",
        text: "progress_startsdk_register",
        order: 5,
      });
    }

    const progressState: ISessionProps = {
      ...location.state,
      progress: progressArr,
      sdkTestType: SDKTestType.Automated,
      sessionStatus: SessionStatus.IncompleteTesting,
      currentPage: location.state?.currentPage + 1,
    };

    amplitudeTrack_continue(location.state, {
      testType: SDKTestType.Automated,
    });

    const basePath = location.pathname.startsWith("/migration") ? "/migration" : "";
    console.log("DEBUG: location.state?.path", location.state?.path);
    if (location.state?.path === IntegrationPathType.StartSDK) {
      navigate(`${basePath}/startsdk/${progressState.os}/testconsole`, {
        state: progressState,
      });
    } else if (location.state?.path === IntegrationPathType.InApp) {
      navigate(`${basePath}/inapp/${progressState.os}/testconsole`, {
        state: progressState,
      });
    } else if (location.state?.path === IntegrationPathType.DeepLink) {
      navigate(`${basePath}/deeplink/${progressState.os}/testconsole`, {
        state: progressState,
      });
    } else if (location.state?.path === IntegrationPathType.AdRevenue) {
      navigate(`/adrevenue/${progressState.os}/testconsole`, {
        state: progressState,
      });
    }
    
  };

  const toManual = () => {
    // Initialize progress with a copy of progressArr
    const progressArr: IProgress[] = location.state?.progress.slice();

    if (location.state?.path === IntegrationPathType.StartSDK) {
      progressArr.push({
        id: "startsdk_testintegration_manual",
        text: "progress_startsdk_testintegration_manual",
        order: 7,
      });
    } else if (location.state?.path === IntegrationPathType.InApp) {
      progressArr.push({
        id: "inapp_testintegration_manual",
        text: "progress_inapp_testintegration_manual",
        order: 4,
      });
    } else if (location.state?.path === IntegrationPathType.AdRevenue) {
      progressArr.push({
        id: "adrevenue_testevents_manual",
        text: "progress_adrevenue_testevents",
        order: 4,
      });
    } else if (location.state?.path === IntegrationPathType.DeepLink) {
      if (location.state?.deeplinkType == DeeplinkType.Deferred) {
        if (!progressArr.some((prog) => prog.id === "dl_testDeferred_manual")) {
          progressArr.push({
            id: "dl_testDeferred_manual",
            text: "progress_dl_testDeferred_manual",
            order: 6,
          });
        }
      } else {
        if (!progressArr.some((prog) => prog.id === "dl_testDirect_manual")) {
          progressArr.push({
            id: "dl_testDirect_manual",
            text: "progress_dl_testDirect_manual",
            order: 7,
          });
        }
      }
    }

    amplitudeTrack_continue(location.state, { testType: SDKTestType.Manual });

    const progressState: ISessionProps = {
      ...location.state,
      progress: progressArr,
      sdkTestType: SDKTestType.Manual,
      sessionStatus: SessionStatus.IncompleteTesting,
      currentPage: location.state?.currentPage + 1,
    };

    const basePath = location.pathname.startsWith("/migration") ? "/migration" : "";
    console.log("DEBUG: location.state?.path", location.state?.path);
    if (location.state?.path === IntegrationPathType.StartSDK) {
      navigate(`${basePath}/startsdk/${progressState.os}/testsdkintegration`, {
        state: progressState,
      });
    } else if (location.state?.path === IntegrationPathType.InApp) {
      if (location.state.isEvgenTesting) {
        navigate(`${basePath}/inapp/${progressState.os}/evgeneventsmanual`, {
          state: progressState,
        });
      } else {
        navigate(`${basePath}/inapp/${progressState.os}/testinappintegration`, {
          state: progressState,
        });
      }
    } else if (location.state?.path === IntegrationPathType.AdRevenue) {
      navigate(`/adrevenue/${progressState.os}/testadrevenueintegration`, {
        state: progressState,
      });
    } else if (location.state?.path === IntegrationPathType.DeepLink) {
      if (location.state?.deeplinkType == DeeplinkType.Deferred) {
        navigate(`${basePath}/deeplink/${progressState.os}/testdeferreddl`, {
          state: progressState,
        });
      } else {
        navigate(`${basePath}/deeplink/${progressState.os}/testDirect`, {
          state: progressState,
        });
      }
    }
  };

  const cardStyle = {
    width: 240,
    height: 280,
    margin: "0 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    paddingTop: 0,
    padding: 15,
  };

  return (
    <Container maxWidth={"lg"}>
      <Box
        textAlign={"center"}
        marginTop={5}
        marginBottom={5}
        padding={5}
        style={{ minHeight: "35vh" }}
      >
        {location.state?.path === IntegrationPathType.StartSDK && (
          <Typography variant="h1">
            {t("startSDK_Step5_android_TestSDKIntegration")}
          </Typography>
        )}
        {location.state?.path === IntegrationPathType.InApp && (
          <Typography variant="h1">
            {t("ip_InAppResults_android_testSDKIntegrationHeading")}
          </Typography>
        )}
        {location.state?.path === IntegrationPathType.DeepLink && (
          <Typography variant="h1">
            {t("deeplink_testSDK_all_testResult_heading")}
          </Typography>
        )}
        {location.state?.path === IntegrationPathType.AdRevenue && (
          <Typography variant="h1">
           {t("adRevenue_Test_Ad_Revenue_Integration")}
           </Typography>
        )}
        <Typography variant="h2">
          {t("testConsole_TestType_testtype")}
        </Typography>
        <Box
          display={"flex"}
          sx={{ mt: 5, flexDirection: { xs: "column", md: "row" } }}
          gap={1}
          justifyContent={"center"}
        >
            {location.state?.path === IntegrationPathType.AdRevenue ? (
    <>
          {/* AUTO TEST FIRST for AdRevenue */}
          <InteractiveCard style={cardStyle} onClick={() => toTestConsole()}>
            <CardContent style={{ textAlign: "left" }}>
              <Box height={30}>
                {/* Recommended badge only in Ad Revenue Page */}
                {location.state?.path === IntegrationPathType.AdRevenue && (
                  <Badge
                    sx={{ ml: "45px", mt: "25px" }}
                    variant="recommended"
                  />
                )}
              </Box>
              <Typography variant="h3">
                {t("testConsole_TestType_autoTest")}
              </Typography>
              <Typography variant="body1">
                {t("testConsole_TestType_autoTest_desc")}
              </Typography>
              <Typography mt={5} style={{ fontWeight: "bold"}}>
                {t("testConsole_TestType_manualTest_desc_b")}
              </Typography>
              <ul style={{ padding: 0, margin: 5 }}>
                <li>
                  <Typography variant="body2">
                    <b>API v2 Token </b>
                    {t("testConsole_TestType_autoTest_desc_c")}
                  </Typography>
                </li>
              </ul>
              <br />
            </CardContent>
          </InteractiveCard>
          <InteractiveCard style={cardStyle} onClick={() => toManual()}>
            <CardContent style={{ textAlign: "left" }}>
              <Box height={30}></Box>
              <Typography variant="h3">
                {t("testConsole_TestType_manualTest")}
              </Typography>
              <Typography variant="body1">
                {t("testConsole_TestType_manualTest_desc")}
              </Typography>
              <Typography mt={2.5} style={{ fontWeight: "bold" }}>
                {t("testConsole_TestType_manualTest_desc_b")}
              </Typography>
              <ul style={{ padding: 0, margin: 5 }}>
                <li>
                  <Typography variant="body2">
                    <b>{t("testConsole_TestType_manualTest_desc_c")}</b>
                  </Typography>
                </li>
              </ul>
            </CardContent>
          </InteractiveCard>

        </>
  ) : (
    <>
          {/* MANUAL FIRST for everything else */}
          <InteractiveCard style={cardStyle} onClick={() => toManual()}>
            <CardContent style={{ textAlign: "left" }}>
              <Box height={30}></Box>
              <Typography variant="h3">
                {t("testConsole_TestType_manualTest")}
              </Typography>
              <Typography variant="body1">
                {t("testConsole_TestType_manualTest_desc")}
              </Typography>
              <br />
              <Typography style={{ fontWeight: "bold" }}>
                {t("testConsole_TestType_manualTest_desc_b")}
              </Typography>
              <ul style={{ padding: 0, margin: 5 }}>
                <li>
                  <Typography variant="body2">
                    <b>{t("testConsole_TestType_manualTest_desc_c")}</b>
                  </Typography>
                </li>
              </ul>
            </CardContent>
          </InteractiveCard>
          <InteractiveCard style={cardStyle} onClick={() => toTestConsole()}>
            <CardContent style={{ textAlign: "left" }}>
              <Box height={30}>
                {/* Recommended badge only in Ad Revenue Page */}
                {location.state?.path === IntegrationPathType.AdRevenue && (
                  <Badge
                    sx={{ ml: "45px", mt: "25px" }}
                    variant="recommended"
                  />
                )}
              </Box>
              <Typography variant="h3">
                {t("testConsole_TestType_autoTest")}
              </Typography>
              <Typography variant="body1">
                {t("testConsole_TestType_autoTest_desc")}
              </Typography>
              <br />
              <br />
              <Typography style={{ fontWeight: "bold" }}>
                {t("testConsole_TestType_manualTest_desc_b")}
              </Typography>
              <ul style={{ padding: 0, margin: 5 }}>
                <li>
                  <Typography variant="body2">
                    <b>API v2 Token </b>
                    {t("testConsole_TestType_autoTest_desc_c")}
                  </Typography>
                </li>
              </ul>
              <br />
            </CardContent>
          </InteractiveCard>
          </>
  )}
        </Box>
      </Box>
      <Box
        display={"flex"}
        width={"100%"}
        justifyContent="space-between"
        alignSelf="end"
        justifySelf="end"
        marginTop={10}
        textAlign="end"
      >
        {" "}
        <Button
          variant="outlined"
          size="medium"
          color="secondary"
          style={{ marginRight: "5px" }}
          onClick={() => navigate(-1)}
        >
          {t("general_Back")}
        </Button>
      </Box>
    </Container>
  );
};

export default transition(TestingTypePath);
